export default __webpack_public_path__ + "static/media/ct213-3.ece1d18c.png";